import {Project, ProjectService} from './../general/project.service';
import {LoadingIndicationService} from 'src/app/services/loading-indication.service';
import {PostData} from './models/post-data.model';
import {PostsService} from './../../services/posts.service';
import {EsoService} from './../eso/eso.service';
import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NotificationService} from 'src/app/services/notification.service';
import {ForecastService} from '../forecast/forecast.service';
import {KpiCaptiondata, KpiObjectData} from './models/kpi-object-data.model';
import {CoreSetting, SettingsService} from '../settings/settings.service';
import {NavigateAssociates} from 'src/app/helpers/navigate-associates';
import {ProjectGanttViewComponent} from 'src/app/widgets/project-gantt-view/project-gantt-view/project-gantt-view.component';

import { AuthService } from 'src/app/services/auth.service';

enum CounterGroups {
	PAGE_LOAD = 1
}

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [EsoService],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit {

	// public dynamicVisualsGroup: DynamicVisualsGroup = <DynamicVisualsGroup>{
	// 	id: 0,
	// 	name: 'Green',
	// 	filtersDynamicVisualsPermutationId: 4,
	// 	childrenFiltersEnabled: true,
	// 	filtersPriorityId: 1
	// };

	public kpiCardsData: KpiObjectData[];
	public kpicaption: KpiCaptiondata[];

	public selectedCarouselButtonIdex: number = 0;

	public buttonItems: any[] = [];

	public onCarouselButtonItemClick(event: any) {
		console.log("onCarouselButtonItemClick", event);

		this.selectedCarouselButtonIdex = event.itemData.index;


	}

	// public newPostPopupActive: boolean;

	// public onPostPopupSave(event: any) {
	// 	console.log("onPostPopupSave - event:", event);
	// }

	// <General page fields>

	public showInfoPopup: boolean;
	public infoPopupMessage: string = "DEFAULT MESSAGE";

	private readonly _componentTitle = "Perito IBP";
	// private readonly _QueryParamName = "NONE";

	// </General page fields>

	public posts: PostData[];

	private _previousPostsLength: number;
	private _carouselPosts: PostData[][];
	public get carouselPosts(): PostData[][] {
		if (this.posts && this._previousPostsLength !== this.posts.length) {
			this._carouselPosts = [];

			this.buttonItems = [];

			for (let a = 0; a < this.posts.length / 3 && a < 4; a++) {
				this.buttonItems.push(
					{
						'index': a
					}
				);
			}

			for (let a = 0; a < this.buttonItems.length; a++) {
				let innerPosts: PostData[] = [];

				for (let b = 0; b < 3; b++) {
					let postIndex = a * 3 + b;

					if (postIndex < this.posts.length) {
						innerPosts.push(this.posts[postIndex]);
					}
				}

				this._carouselPosts.push(innerPosts);
			}

			this._previousPostsLength = this.posts.length;
		}

		return this._carouselPosts;
	}

	public initializePosts() {
		this.postsService.getLatestPosts(-1, 12).subscribe(
			(response) => {
				console.log("initializePosts -> getLatestPosts - response:", response);

				this.posts = [];

				for (let a = 0; a < response.length; a++) {
					const postData = response[a];

					this.posts.push(postData);
				}
			}
		);
	}

	@ViewChild('projectGanttView', {static: false}) projectGanttView: ProjectGanttViewComponent;

	public displayMainProjectOnHomePage: boolean = false;
	public mainProject: Project;

	public initializeProjectGanttView() {
		console.log("initializeProjectGanttView");

		const $this = this;

		this.settingsService.getCoreSetting(null, "DisplayMainProjectOnHomePage").then(
			(response) => {
				console.log("initializeColorValues -> getCoreSetting - response:", response);

				$this.displayMainProjectOnHomePage = response.value === 'Yes';

				if ($this.displayMainProjectOnHomePage) {
					$this.settingsService.getCoreSetting(null, "MainProjectId").then(
						(response) => {
							$this._projectService.getProject(+response.value).subscribe(
								(response) => {
									console.log("initializeProjectGanttView -> getProject - response:", response);

									$this.mainProject = response;

									$this.projectGanttView.loadGanttData($this.mainProject.id);
								}
							);
						}
					);
				}
			},
			(error) => {
				console.error(error);



				$this.notificationService.error(error);
			}
		);
	}

	constructor(
		private titleService: Title,
		private notificationService: NotificationService,
		private settingsService: SettingsService,
		private forecastService: ForecastService,
		private postsService: PostsService,
		private navigates: NavigateAssociates,
		private _projectService: ProjectService,
		public authService: AuthService,
	) {}

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);
		this.authService.castApplicationTitle.subscribe(select => {
			this.titleService.setTitle(select);
		});



		this.initializeKpiCardsData();
		this.initializeCoreSettings();

		this.initializePosts();
	}

	ngAfterViewInit(): void {
		this.initializeProjectGanttView();
	}

	private initializeKpiCardsData() {
		this.forecastService.getKpiObjects().subscribe(
			(response) => {
				this.kpiCardsData = response.kpiObjectDetails;
				this.kpicaption = response.kpiCaptions;
			}
		);
	}

	// public dynamicVisualsGroupsCombinationTableDataOperator: TableDataOperator<DynamicVisualsGroupsCombination> = new TableDataOperator(
	// 	new SelectStatementOptions(
	// 		{
	// 			baseSelectStatementId: BaseSelectStatementId.DEV_GetDynamicVisualsGroupsCombinations
	// 		}
	// 	),
	// 	DynamicVisualsGroupsCombination
	// );

	//public dynamicVisualsGroupCombination: DynamicVisualsGroupsCombination;

	public displayDashboardSetting: CoreSetting;

	private _dashboardSetting: CoreSetting;
	public get dashboardSetting(): CoreSetting {
		return this._dashboardSetting;
	}
	public set dashboardSetting(value: CoreSetting) {
		this._dashboardSetting = value;

		
	}

	public arrowColorValues: Map<number, string>;
	public lineChartIndicatorColor: string;
	public postCardBackgroundColor: string;
	public postCardInfoTitleTextColor: string;
	public postCardMainTextColor: string;
	public postCardPriorityIndicatorTextColor: string;
	public postCardPriorityBackgroundColor: string;

	//TODO: Optimize this to 1 request call.
	public initializeCoreSettings() {
		this.arrowColorValues = new Map<number, string>();

		const $this = this;

		this.settingsService.getCoreSetting(null, "KpiArrowGood").then(
			(response) => {
				$this.arrowColorValues.set(1, response.value);
			}
		);

		this.settingsService.getCoreSetting(null, "KpiArrowNeutral").then(
			(response) => {
				$this.arrowColorValues.set(0, response.value);
			}
		);

		this.settingsService.getCoreSetting(null, "KpiArrowBad").then(
			(response) => {
				$this.arrowColorValues.set(-1, response.value);
			}
		);

		this.settingsService.getCoreSetting(null, "KpiLineChartIndicatorColor").then(
			(response) => {
				$this.lineChartIndicatorColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardBackgroundColor").then(
			(response) => {
				$this.postCardBackgroundColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardInfoTitleTextColor").then(
			(response) => {
				$this.postCardInfoTitleTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardMainTextColor").then(
			(response) => {
				$this.postCardMainTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardPriorityIndicatorTextColor").then(
			(response) => {
				$this.postCardPriorityIndicatorTextColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "PostCardPriorityBackgroundColor").then(
			(response) => {
				$this.postCardPriorityBackgroundColor = response.value;
			}
		);

		this.settingsService.getCoreSetting(null, "HomePageDisplayDashboard").then(
			(response) => {
				$this.displayDashboardSetting = response;
			}
		);

		this.settingsService.getCoreSetting(null, "HomePageDashboard").then(
			(response) => {
				$this.dashboardSetting = response;
			}
		);
	}

	public onPostCardClick(postData: PostData) {
		console.log("onPostCardClick - postData:", postData);

		this.navigates.navigateTO(`/general/feed`, `?id=${postData.id}`)
	}

	// <Toggles>



	public toggleInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
	}

	// </Toggles>
}
